import { Page } from 'layouts/Page';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import { getAvailableVatReportTypes } from 'redux/reducers/auth/selectors';
import { VerticalMenu } from 'ui/VerticalMenu';
import { Box } from '@mui/material';
import { VAT_REPORTS } from 'redux/reducers/reports/constants';
import { TMenuItem } from 'ui/VerticalMenu/types';
import { VatReports } from 'components/VatReports';
import { PATHS } from 'routes/constants';
import { useParams } from 'react-router-dom';

export const VatReportsPage: FC = () => {
	const params = useParams<{ typeOfReport?: string }>();
	const { typeOfReport } = params;
	const vatReports = VAT_REPORTS.find((item) => item.path === typeOfReport);

	const availableVatReportTypes = useSelector(getAvailableVatReportTypes);

	return (
		<Page title={`${vatReports?.title ?? ''}  VAT Reports – EAS Dashboard`}>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					flexDirection: { xs: 'column', md: 'row' },
				}}
			>
				<Box sx={{ minWidth: '200px' }}>
					{availableVatReportTypes && (
						<VerticalMenu
							items={
								availableVatReportTypes
									.map((key) => VAT_REPORTS.find((report) => key === report.type))
									.filter(Boolean) as TMenuItem[]
							}
							path={PATHS.VAT_REPORTS_PAGE}
						/>
					)}
				</Box>
				<Box sx={{ width: { md: 'calc(100vw - 200px - 20px)', xs: 'auto' }, m: '0 10px' }}>
					<VatReports />
				</Box>
			</Box>
		</Page>
	);
};
